import React, { memo, useContext, useEffect } from 'react';
import { WebsiteDesignType } from '../../../catalog/enums/WebsiteDesignType';
import { isValidObject } from '../../../catalog/Validity';
import { context } from '../../../globalState/GlobalState';
import HomePage0 from '../../designs/homePage0/HomePage0';
import HomePage1 from '../../designs/homePage1/HomePage1';
import { createHomePageDescriptionTag, createHomePageKeywordsTag, createHomePageTitleTag } from '../uiElements/helmet/MetaTags';
import TitleAndDescriptionTags from '../uiElements/helmet/TitleAndDescriptionTags';
import { sendHomePageAnalytics } from '../../../catalog/Analytics';
import { optimXTesting } from '../../../catalog/TeamInfo';

const HomePage = () => {
    const { globalState } = useContext(context);

    useEffect(() => {
        sendHomePageAnalytics(globalState);
    }, [globalState]);

    const getHomePageDesign = () => {
        if (!isValidObject(globalState) || !isValidObject(globalState.websiteStyles)) {
            if (!optimXTesting) {
                return (<HomePage0 />);
            }
            return null;
        }

        if (globalState.websiteStyles.design.homepage === WebsiteDesignType.DESIGN_1) {
            return (<HomePage1 />);
        }
        return (<HomePage1 />);
    };

    return (
        <>
            <TitleAndDescriptionTags
                title={createHomePageTitleTag(globalState)}
                description={createHomePageDescriptionTag(globalState)}
                keywords={createHomePageKeywordsTag(globalState)}
            />
            {getHomePageDesign()}
        </>
    );
};

export default memo(HomePage);
